import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const getAllChatsAPI = async ({ management_id, user_id, offset, limit, search }) => {
    const queryParams = {
        management_id,
        user_id: user_id ? user_id : undefined,
        offset: offset ? offset : 1,
        limit: limit ? limit : 100,
        search: search ? encodeURIComponent(search) : '',
    };
    const url = constructURL(API.CHATS, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const getAllChatUsersAPI = async ({ csm_id, search, limit }) => {
    const queryParams = {
        limit: limit ? limit : 100,
        search: search ? encodeURIComponent(search) : '',
    };
    const url = constructURL(`${API.CHATS}/${csm_id}`, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const createChatAPI = async ({ management_id, user_id }) => {
    const body = {
        management_id,
        user_id,
    };
    return fetchData({ method: METHODS.POST, url: API.CHATS, body });
};

export const getAllMessagesAPI = async ({ chat_id, limit, search, before }) => {
    const queryParams = {
        chat_id,
        limit: limit ? limit : 50,
        before: before ? before : undefined,
        search: search ? encodeURIComponent(search) : undefined,
    };
    const url = constructURL(API.CHAT_MESSAGES, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const sendMessageAPI = async ({
    id,
    chat_id,
    sender_id,
    message,
    type,
    s3_key,
    file_name,
    file_size,
}) => {
    const body = {
        id: id ? id : undefined,
        chat_id,
        sender_id,
        message,
        type: type ? type : undefined,
        s3_key: s3_key ? s3_key : undefined,
        file_name: file_name ? file_name : undefined,
        file_size: file_size ? file_size : undefined,
    };

    return fetchData({ method: METHODS.POST, url: API.CHAT_MESSAGES, body });
};

export const markReadChatMessagesAPI = async ({ chat_id }) => {
    return fetchData({ method: METHODS.PATCH, url: `${API.CHAT_MESSAGES}/${chat_id}` });
};

export const getAllOnlineUsersAPI = async () => {
    return fetchData({ method: METHODS.GET, url: API.ONLINE_USERS });
};
